var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoubleArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 52,
  viewBox: "0 0 48 52"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "DoubleArrowLeft",
  fill: "#E1BF87",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  id: "$",
  d: "M.413 3.123 24.263 28l2.127-2.056L2.54 1.067a1.473 1.473 0 0 0-2.087-.04 1.485 1.485 0 0 0-.04 2.096",
  transform: "matrix(-1 0 0 1 26.39 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "$",
  d: "m0 26.056 23.85 24.877a1.473 1.473 0 0 0 2.087.04 1.485 1.485 0 0 0 .04-2.096L2.127 24z"
}), /*#__PURE__*/React.createElement("path", {
  id: "$",
  d: "M21.413 3.123 45.263 28l2.127-2.056L23.54 1.067a1.473 1.473 0 0 0-2.087-.04 1.485 1.485 0 0 0-.04 2.096",
  transform: "matrix(-1 0 0 1 68.39 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "$",
  d: "m21 26.056 23.85 24.877a1.473 1.473 0 0 0 2.087.04 1.485 1.485 0 0 0 .04-2.096L23.127 24z"
})))));
export default SvgDoubleArrowLeft;